export const CARD_PLACEHOLDER_IMAGE_ID = "Placeholder_CS.png";
